import React from "react";

const ShimmerUI = () => {
  return <div className="w-40 h-60 bg-gray-300 rounded-md"></div>;
};

export default ShimmerUI;
